export class ConnectionError extends Error {
  constructor(
    message: string,
    public baseUrl: string,
    public uri: string,
    public statusCode: number
  ) {
    super(message);
    this.name = "ConnectionError";
  }
}
